import React ,{useEffect,useState}from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './Pages/Home.jsx';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Tour_page from './Pages/Tour_page.jsx';
import Activity_page from './Pages/Activity_page.jsx';
import Transport_page from './Pages/Transport_page.jsx';
import Hotel_page from './Pages/Hotel_page.jsx';
import Itinary_page from './Pages/Itinary_page.jsx';
import SignUp from './Pages/SignUp.jsx';
import 'react-toastify/dist/ReactToastify.css';
import Group_tour from './Pages/Group_tour.jsx';
import Package_tour from './Pages/Package_tour.jsx';
import Weekend_tour from './Pages/Weekend_tour.jsx';
import TourOverview from './Components/TourOverview.jsx';
import Profile from './Pages/Profile.jsx';
import Edit_profile from './Components/Edit_profile.jsx';
import Tour_information from './Components/Tour_information.jsx';
import Upcoming_tour_content from './Components/Upcoming_tour_content.jsx';
import Past_tour_content from './Components/Past_tour.jsx';
import Bookmarked_tour_content from './Components/Bookmarked.jsx';
import Reviews_content from './Components/Reviews.jsx';
import Settings from './Components/Settings.jsx';
import HotelDetails from './Components/HotelDetails.jsx';
import ReviewBooking from './Components/ReviewBooking.jsx';
import ItineraryFinal from "./Components/ItineryFinal.jsx"
import Hotel_Gallery from './Components/Gallery_hotel.jsx';
import BusCard from './Components/BusCard.jsx';
import Transport_Review_page from "./Components/BusBookingReviewPage.jsx"
import CabBookingPage from './Components/CabBookingPage.jsx';
import CabBookingReviewPage from "./Components/CabBookingReviewPage.jsx"
import CustomTour from './Components/CustomPackage.jsx';
import TourReviewBooking from "./Components/TourBookingReview.jsx"
import ProfileHotelInformation from './Components/ProfileHotelInformation.jsx';
import ProfileHotelBooked from './Components/ProfileHotelBooked.jsx';
import ProfileHotelPending from './Components/ProfileHotelPending.jsx';
import ProfileHotelBookmarked from './Components/ProfileHotelBookmarked.jsx';
import ProfileHotelReviews from './Components/ProfileHotelReviews.jsx';
import ActivityDetails from './Components/ActivityDetails.jsx';
import UserAgreement from './Privacy_folder/UserAgreement.jsx';
import TermsOfService from './Privacy_folder/TermsOfService.jsx';
import CancellationPolicy from './Privacy_folder/CancellationPolicy.jsx';
import PrivacyPolicy from './Privacy_folder/Privacy_Policy.jsx';
import ProfileActivityInformation from './Components/ProfileActivityInformation.jsx';
import ProfileActivityUpcoming from './Components/ProfileActivityUpcoming.jsx';
import ProfileActivityPassed from './Components/ProfileActivityPassed.jsx';
import PlanTour from "./Pages/PlanTour.jsx"
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import PackageTourDetails from './Components/PackageTourDetails.jsx';
import GroupTourDetails from './Components/GroupTourDetails.jsx';
import WeekendTourDetails from './Components/WeekendTourDetails.jsx';
import ImageSlider from './Components/Helping Component/ItinerarySlider.jsx';
import ScrollToTop from "./Components/Helping Component/ScrollToTop.jsx"
import Footer from "./Pages/Footer.jsx"
import Franchise from './Pages/Franchise_Page/Franchise.jsx';
import BecomePartner from './Pages/Partner_page/BecomePartner.jsx';
import Awards from './Pages/Awards/Awards.jsx';
import ExternalPage from './Pages/ExternalPage/Main_Page.jsx';
import MainResult from './Pages/ExternalPage/MainResult.jsx';
import Jayraj_transport from './Pages/Transport_Page/Jayraj_transport.jsx';
import Gallery from './Pages/Gallery_Page/Gallery.jsx';
import FranchiseInformaton from './Components/ProfileFranchiseInformation.jsx';
import Profile_Tour_commision from './Components/Profile_Tour_commision.jsx';
import Profile_Hotel_commision from './Components/Profile_Hotel_commision.jsx';
import Profile_Activity_commision from './Components/Profile_Activity_commision.jsx';
import Profile_Transport_commision from './Components/Profile_Transport_commision.jsx';
import FlightSearchResult from './Pages/Transport_Page/SearchResult/FlightSearchResult.jsx';
import FlightCheckout from "./Pages/Transport_Page/FlightCheckoutPage/FlightCheckout.jsx"
import Profile_Flight from "./Components/ProfileFlightInformation.jsx"
import Profile_Flight_Upcomming from "./Components/ProfileFlightUpcoming.jsx"
import ProfileFlightPassed from './Components/ProfileFlightPassed.jsx';
import BusSearchPage from './Pages/Transport_Page/SearchResult/BusSearchPage.jsx';
import PassengerDetailsPage from './Pages/Transport_Page/BusPassenger/PassengerDetailsPage.jsx';
import BusInfo from './Pages/Transport_Page/OrderPage/BusInfo.jsx';
import FlightTicket from './Pages/Transport_Page/FlightCheckoutPage/FlightTicket.jsx';
import DestinationWedding from './Pages/Destination_Wedding/Home/MainLayout.jsx';
import DestinationWeddingPage from './Pages/Destination_Wedding/Destinations/Mainlayout.jsx';
import DestinationWeddingPackages from './Pages/Destination_Wedding/PackageDetails/PackagePage.jsx';
import DestinationWeddingPackagesDetails from './Pages/Destination_Wedding/PackageDetails/PackageDetailsPage.jsx';
import ProfileDestinationWeddingInformation from './Pages/Destination_Wedding/Profile/Mainlayout.jsx';
import UpcommingWeddingContent from './Pages/Destination_Wedding/Profile/UpcomingWedding.jsx';
import PassedWeddingContent from './Pages/Destination_Wedding/Profile/PastWedding.jsx';
import Honeymoon from "./Pages/Honeymoon/Home/MainLayout.jsx"
import HoneymoonPackages from "./Pages/Honeymoon/Packages/Mainlayout.jsx"
import HoneymoonDetails from "./Pages/Honeymoon/Packages/HoneymoonDetailsPage.jsx"
import PorfileHoneymoonInformation from './Pages/Honeymoon/Profile/UpcomingHoneymoon.jsx';
import Blogs from './Pages/Blog/Blogs.jsx';
import BlogDetails from './Pages/Blog/BlogDetails.jsx';
import { BookingProvider } from './Pages/CabBooking/context/BookingContext';
import { CabBookingRoutes } from './Pages/CabBooking';
import ProfileBookingHistory from './Pages/CabBooking/ProfileBookingHistory';



function App() {
  
//   useEffect(() => {
//   document.addEventListener('contextmenu', (e) => {
//     e.preventDefault();
//     return false;
//   });

//   document.addEventListener("copy", function (e) {
//         e.preventDefault();
//     });

//   document.addEventListener('keydown', (e) => {
//     // Block F12
//     if (e.key === 'F12' || e.keyCode === 123) {
//       e.preventDefault();
//       return false;
//     }
    
//     // Block Ctrl+Shift+I (Inspect)
//     if (e.ctrlKey && e.shiftKey && e.key === 'I') {
//       e.preventDefault();
//       return false;
//     }
    
//     // Block Ctrl+Shift+J (Console)
//     if (e.ctrlKey && e.shiftKey && e.key === 'J') {
//       e.preventDefault();
//       return false;
//     }
    
//     // Block Ctrl+U (View Source)
//     if (e.ctrlKey && e.key === 'u') {
//       e.preventDefault();
//       return false;
//     }
    
//     // Block Ctrl+Shift+C (Inspect Element)
//     if (e.ctrlKey && e.shiftKey && e.key === 'C') {
//       e.preventDefault();
//       return false;
//     }
//   });
// }, []);



// const [blocked, setBlocked] = useState(false);

// useEffect(() => {
//   const detectDevTools = () => {
//     const start = new Date();
//     debugger; 
//     const end = new Date();

//     if (end - start > 100) {
//       alert("please off the inspect tab");
//       setBlocked(true);
//     } else {
//       setBlocked(false);
//     }
//   };

//   const interval = setInterval(detectDevTools, 1000);
//   return () => clearInterval(interval);
// }, []);

//   if (blocked) {
//     return (
//       <div style={{ textAlign: "center", marginTop: "100px" }}>
//         <h1>Access Denied 🚫</h1>
//       </div>
//     );
//   }



  return (
    <div className="App">
      <ScrollToTop />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/tour" element={<Tour_page/>} /> */}
                    <Route path="/bus-results" element={<BusSearchPage />} />
          <Route path="/passenger-details" element={<PassengerDetailsPage />} />
          <Route path="/search-results" element={<MainResult />} />
          <Route path="/hotels" element={<Hotel_page />} />
          <Route path="/user-agreement" element={<UserAgreement />} />
          <Route path="/terms-of-services" element={<TermsOfService />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/destination-images/:id" element={<ImageSlider />} />
          <Route path="/franchise" element={<Franchise />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:slug" element={<BlogDetails />} />
          <Route path="/cab/*" element={<BookingProvider><CabBookingRoutes /></BookingProvider>} />



          <Route path="/destination-wedding" element={<DestinationWedding />} />
          <Route path="/wedding-destinations" element={<DestinationWeddingPage />} />
          <Route path="/destination-wedding-packages/:id" element={<DestinationWeddingPackages />} />
          <Route path="/destination-wedding-packages-details/:slug" element={<DestinationWeddingPackagesDetails />} />




          <Route path="/honeymoon" element={<Honeymoon />} />
          <Route path="/honeymoon/packages" element={<HoneymoonPackages />} />
          <Route path="/honeymoon/packages/:slug" element={<HoneymoonDetails />} />



          <Route path="/become-partner" element={<BecomePartner />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/flight-checkout" element={<FlightCheckout />} />

          <Route path="/awards" element={<Awards />} />
          <Route path="/search-page" element={<ExternalPage />} />
          <Route path="/flight-search-result" element={<FlightSearchResult />} />

          <Route path="/flight-ticket" element={<FlightTicket />} />
          <Route path="/transports" element={<Transport_page />} >
          

            <Route index element={<BusCard />} />
            <Route path='cab' element={<CabBookingPage />} />
          </Route>
          <Route path="/jayraj-transports/:button" element={<Jayraj_transport />} >

            <Route index element={<BusCard />} />
            <Route path='cab' element={<CabBookingPage />} />
          </Route>
          <Route path="/activities" element={<Activity_page />} />
          <Route path="/itinary" element={<Itinary_page />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/tour/grouptour" element={<Group_tour />} />
          <Route path="/tour/packagetour" element={<Package_tour />} />
          <Route path="/tour/weekendtour" element={<Weekend_tour />} />
          <Route path="/tour/customtour" element={<CustomTour />} />
          <Route path="/tour/plantour" element={<PlanTour />} />

          <Route path="/tour/touroverview/:id" element={<TourOverview />} />
          <Route path="/tour/packagetour/:slugId" element={<PackageTourDetails />} />
          <Route path="/tour/grouptour/:slugId" element={<GroupTourDetails />} />
          <Route path="/tour/weekendtour/:slugId" element={<WeekendTourDetails />} />
          <Route path="/tour/plantour/:slugId" element={<PlanTour />} />
          <Route path="/hotel/:slugId" element={<HotelDetails />} />
          <Route path="/hotel/reviewbooking/:slugId" element={<ReviewBooking />} />
          <Route path="/destinations/:destinationId/tours/:tourId/itinerary/:custId/:bookingID" element={<ItineraryFinal />} />
          <Route path="/hotel/gallery/:id" element={<Hotel_Gallery />} />
          <Route path='/transport-review-page' element={<Transport_Review_page />} />
          <Route path='/transports-cab-review-page' element={<CabBookingReviewPage />} />
          <Route path='/tour-review/:slugId' element={<TourReviewBooking />} />
          <Route path='/activity/:slugId' element={<ActivityDetails />} />
          <Route path='/profile' element={<Profile />}>
            <Route index element={<Edit_profile />} />
             <Route path="Bus-info" element={<BusInfo />} />
            <Route path="tour-info" element={<Tour_information />} >
              <Route index element={<Upcoming_tour_content />} />
              <Route path="past" element={<Past_tour_content />} />
              <Route path="bookedmarked" element={<Bookmarked_tour_content />} />
              <Route path="reviews" element={<Reviews_content />} />
              <Route />
            </Route>
            <Route path="hotel-info" element={<ProfileHotelInformation />} >
              <Route index element={<ProfileHotelBooked />} />
              <Route path="pending" element={<ProfileHotelPending />} />
              <Route path="bookedmarked" element={<ProfileHotelBookmarked />} />
              <Route path="reviews" element={<ProfileHotelReviews />} />
              <Route />
            </Route>
            <Route path="activity-info" element={<ProfileActivityInformation />} >
              <Route index element={<ProfileActivityUpcoming />} />
              <Route path="passed" element={<ProfileActivityPassed />} />
            </Route>
            <Route path="destination-wedding" element={<UpcommingWeddingContent />} >
              {/* <Route index element={<UpcommingWeddingContent />} />
              <Route path="past" element={<PassedWeddingContent />} /> */}
            </Route>
            <Route path="honeymoon" element={<PorfileHoneymoonInformation/>} >
            </Route>
            <Route path="cab" element={<ProfileBookingHistory />} />
            <Route path="flight-info" element={<Profile_Flight />} >
              <Route index element={<Profile_Flight_Upcomming />} />
              <Route path="passed" element={<ProfileFlightPassed />} />
            </Route>
            {/* <Route path="franchise" element={<FranchiseInformaton />} /> */}
            <Route path="franchise" element={<FranchiseInformaton />} >
              <Route index element={<Profile_Tour_commision />} />
              <Route path="hotel" element={<Profile_Hotel_commision />} />
              <Route path="activity" element={<Profile_Activity_commision />} />
              <Route path="transport" element={<Profile_Transport_commision />} />
              <Route />
            </Route>
            <Route path="settings" element={<Settings />} />
            <Route path="logout" element={<div>Logout Content</div>} />
          </Route>

        </Routes>
        <Footer />
      </LocalizationProvider>
    </div>
  );
}

export default App;
